import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as Styled from './SearchInput.styled';

// Used for searching. Has no error message component.
// Can be controlled or an un controlled component depending on whether value is passed or not.
const SearchInput = (props) => {
  const {
    className,
    classes,
    disabled,
    adornment,
    inputRef,
    labelId,
    ...passThroughProps
  } = props;

  return (
    <Styled.RootComponent className={classnames(classes.root, className)}>
      <Styled.BaseInput
        adornment={adornment ? 'true' : ''}
        disabled={disabled}
        className={classes.input}
        ref={inputRef}
        aria-labelledby={labelId}
        {...passThroughProps}
      />
      {adornment && (
        <Styled.AdornmentContainer className={classes.adornmentContainer}>
          {adornment}
        </Styled.AdornmentContainer>
      )}
    </Styled.RootComponent>
  );
};

SearchInput.propTypes = {
  className: PropTypes.string,
  adornment: PropTypes.node,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string,
    input: PropTypes.string,
    adornmentContainer: PropTypes.string,
  }),
  disabled: PropTypes.bool,
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  labelId: PropTypes.string,
};

SearchInput.defaultProps = {
  className: '',
  adornment: null,
  placeholder: '',
  classes: {
    root: '',
    input: '',
    adornmentContainer: '',
  },
  disabled: false,
  type: 'search',
  labelId: '',
};

SearchInput.AdornmentPrimaryButton = Styled.AdornmentPrimaryButton;
SearchInput.AdornmentSecondaryButton = Styled.AdornmentSecondaryButton;
SearchInput.SearchIconButton = Styled.SearchIconButton;

export default SearchInput;
